<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'預約查詢'"></app-nav-header>  
              <ng-container *ngIf="model.length>0;else nobody">
                <p-table [value]="model" [paginator]="true" [rows]="10" class="custom-table" [tableStyle]="{ 'min-width': '50rem' }" [loading]="loading">
                      <ng-template pTemplate="header">
                          <tr>
                              <th>No</th>
                              <th>類別</th>
                              <th>內容</th>
                              <th>寵物</th>
                              <th>功能</th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
                          <tr>
                              <td>{{ ri+1 }}</td>
                              <td>{{ rowData.Type }}</td>
                              <td class="wrap">{{ rowData.Content }}</td>
                              <td>{{ rowData.PetName }}</td>
                              <td>
                                <ng-container *ngIf="!!rowData.SignPath;else noPath">
                                  <img src="{{baseUrl}}/{{ rowData.SignPath }}" width="100px">
                                </ng-container>
                                <ng-template #noPath>
                                  <p-button label="簽名" [raised]="true" (onClick)="Sign(rowData)"/>
                                </ng-template>
                                <p-button label="取消" [raised]="true" (onClick)="Cancel(rowData)" [disabled]="CheckDisable(rowData)"/>
                              </td>
                          </tr>
                      </ng-template>
                  </p-table>
                  <p-sidebar [(visible)]="showDialog" [fullScreen]="true" (onHide)="onSidebarHide()">
                    <ng-container *ngIf="!isConsentLoading;else nocontent">
                      <ng-template pTemplate="header">
                            <span class="font-semibold text-xl">
                              簽名板
                            </span>
                      </ng-template>
                      <p-scrollPanel #consentFormScrollPanel [style]="{ width: '100%', height: '400px','padding':'10px' }">
                        <div class="signature-container p-3">
                          <p [style]="{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }">{{ consentFormContent }}</p>
                          <div class="flex gap-3">
                              <div class="sign-box">
                                <span class="sign-hint">請於此區域內簽名</span>
                                <ngx-signature-pad #sig [options]="options" class="sign-canvas"
                                      (beginSign)="onBegin()"
                                      (endSign)="onEnd()">
                                  </ngx-signature-pad>
                              </div>
                              <button pButton label="清除" class="p-button-secondary w-full" (click)="clear()"></button>
                              <button pButton label="儲存" class="p-button-success w-full" (click)="save()"></button>
                          </div>
                          </div>
                      </p-scrollPanel>
                    </ng-container>
                    <ng-template #nocontent>
                        <p-progressSpinner ariaLabel="loading" />
                    </ng-template>
                  </p-sidebar> 
              </ng-container>
              <ng-template #nobody>
                <div class="empty-container">
                  <p>目前無預約紀錄</p>
                </div>
              </ng-template>            
</ng-container>
<ng-template #Loading>
  <p-progressSpinner ariaLabel="loading" />
</ng-template>
